import { AppStatusEnum, PlanEnum } from 'api-bible-shared-lib/utils/types';

import { usePlans } from '../contexts/Plans';
import { useApplications } from '../contexts/Applications';
import PlanCard from './PlanCard';

interface PlanSelectionProps {
  handlePlanSelect: (plan: string) => void;
  currentPlan?: string;
  selectedPlan?: string;
  isAllowedByolPlan?: boolean;
}

export default function PlanSelection({
  currentPlan,
  selectedPlan,
  handlePlanSelect,
  isAllowedByolPlan = false,
}: PlanSelectionProps) {
  const { plansById } = usePlans();
  const { applicationsById, maxFreeAppsAllowed } = useApplications();

  const allowedPlanIds = isAllowedByolPlan
    ? Object.keys(plansById)
    : Object.keys(plansById).filter((planId) => planId !== PlanEnum.BYOL);

  const allowFreeApp =
    maxFreeAppsAllowed >
    Object.values(applicationsById).filter(
      (app) => app.plan === PlanEnum.FREE && app.status !== AppStatusEnum.CANCELED,
    ).length;

  return (
    <div className="flex flex-col items-center w-full lg:items-stretch lg:flex-row">
      {allowedPlanIds.map((planId, index) => (
        <PlanCard
          key={`plan-${planId}`}
          planId={planId}
          plan={plansById[planId]}
          className={`w-full max-w-xm mb-6 lg:mb-0
            ${index < allowedPlanIds.length - 1 ? 'lg:mr-5' : ''}
            ${planId === selectedPlan ? 'scale-105' : ''}`}
          onSelect={handlePlanSelect}
          disabled={
            plansById[planId].isUpcoming ||
            planId === currentPlan ||
            (planId === PlanEnum.FREE && !allowFreeApp)
          }
        >
          {currentPlan ? 'Switch to' : 'Choose'}
        </PlanCard>
      ))}
    </div>
  );
}
